<ng-container *transloco="let t">
  <!-- PAYMENT BUTTONS-->
  <section [class.sticky]="!(biggerThan$ | async)?.sm" class="featured-buy-buttons">
    <!-- CHECKOUT_SESSION BUTTONS -->

    <ng-container *ngIf="product && product?.inStock">
      <!-- POPSY GO TO CHECKOUT -->
      <!-- <ng-container *ngIf="showBuyNow">
        <a
          appElementLoaded
          #buyButton
          href="#"
          class="button popsy-button-primary highlight buy-button"
          (click)="onAddToCartShowingInsurancePromo()"
          (elementLoaded)="onBuyNowButtonLoaded()">
          <span class="text">{{ t('action_buy_now') }}</span>
        </a>
        <span class="fixed-space-8" aria-hidden="true"></span>
      </ng-container> -->
      <!-- POPSY ADDTOCART -->
      <popsy-add-to-cart-button [product]="product"></popsy-add-to-cart-button>
    </ng-container>

    <!-- PRODUCT OUT OF STOCK -->
    <ng-container *ngIf="product && !product?.inStock">
      <button
        appElementLoaded
        [disabled]="true"
        class="button popsy-button-primary buy-button full-width"
        [attr.aria-label]="t('label_not_available')">
        <span class="text">{{ t('label_not_available') }}</span>
      </button>
    </ng-container>
  </section>
</ng-container>
